(function () {
  var globalBadgesCache = null;
  var widgetObservers = {};
  var widgetRetryTimers = {};
  var RETRY_DELAYS_MS = [0, 50, 150, 300, 500];
  var OBSERVER_TIMEOUT_MS = 3000;

  function parseGlobalBadges() {
    if (globalBadgesCache !== null) return globalBadgesCache;

    var el = document.getElementById('promo-badges-global');
    if (!el) {
      globalBadgesCache = [];
      return globalBadgesCache;
    }

    try {
      var data = JSON.parse(el.textContent);
      globalBadgesCache = Array.isArray(data) ? data : [];
    } catch (error) {
      globalBadgesCache = [];
    }

    return globalBadgesCache;
  }

  function normalizeBadgeList(value) {
    if (!value) return [];

    if (Array.isArray(value)) return value;

    if (typeof value === 'string') {
      try {
        var parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : value.trim() ? [value] : [];
      } catch (error) {
        return value.trim() ? [value] : [];
      }
    }

    return [];
  }

  function getMetafieldValue(metafields, namespace, key) {
    if (!metafields) return null;

    var dottedKey = namespace + '.' + key;

    if (metafields[dottedKey] !== undefined) {
      var dottedEntry = metafields[dottedKey];
      return dottedEntry && typeof dottedEntry === 'object' && 'value' in dottedEntry
        ? dottedEntry.value
        : dottedEntry;
    }

    if (metafields[namespace] && metafields[namespace][key] !== undefined) {
      var nestedEntry = metafields[namespace][key];
      return nestedEntry && typeof nestedEntry === 'object' && 'value' in nestedEntry
        ? nestedEntry.value
        : nestedEntry;
    }

    if (Array.isArray(metafields)) {
      var match = metafields.find(function (metafield) {
        return metafield.namespace === namespace && metafield.key === key;
      });
      return match ? match.value : null;
    }

    return null;
  }

  function getProductBadges(product) {
    return normalizeBadgeList(getMetafieldValue(product.metafields, 'custom', 'promo_badges'));
  }

  function escapeHtml(text) {
    var el = document.createElement('div');
    el.textContent = text;
    return el.innerHTML;
  }

  function buildBadgesHtml(globalBadges, productBadges) {
    var badges = [];

    globalBadges.forEach(function (badge) {
      if (badge && String(badge).trim()) badges.push(String(badge).trim());
    });

    productBadges.forEach(function (badge) {
      if (badge && String(badge).trim()) badges.push(String(badge).trim());
    });

    if (!badges.length) return '';

    var spans = badges
      .map(function (badge) {
        return '<span class="promo-badges__badge">' + escapeHtml(badge) + '</span>';
      })
      .join('');

    return '<div class="promo-badges promo-badges--card">' + spans + '</div>';
  }

  function getWidgetRoot(widget) {
    if (!widget || !widget.id) return null;

    var id = String(widget.id);
    var widgetEl = document.getElementById('rebuy-widget-' + id);
    if (widgetEl) return widgetEl;

    if (widget.element) return widget.element;
    if (widget.dom) return widget.dom;
    if (widget.$el) return widget.$el;
    if (widget.view && widget.view.$el) return widget.view.$el;

    var mount = document.querySelector('[data-rebuy-id="' + id + '"]');
    if (mount) return mount.closest('.rebuy-widget') || mount;

    return null;
  }

  function getObserverTarget(widget) {
    var id = String(widget.id);
    return (
      document.getElementById('rebuy-widget-' + id) ||
      document.querySelector('[data-rebuy-id="' + id + '"]') ||
      getWidgetRoot(widget)
    );
  }

  function findProductBlock(widget, productId, root) {
    var id = String(widget.id);
    var selector = '.rebuy-product-block.product-id-' + productId;
    var widgetEl = document.getElementById('rebuy-widget-' + id);
    var block = null;

    if (widgetEl) {
      block = widgetEl.querySelector(selector);
      if (block) return block;
    }

    if (root) {
      block = root.querySelector(selector);
      if (block) return block;
    }

    var mount = document.querySelector('[data-rebuy-id="' + id + '"]');
    if (mount) {
      block = mount.querySelector(selector);
      if (block) return block;
    }

    return document.querySelector(selector);
  }

  function clearBadges(root) {
    if (!root) return;
    root.querySelectorAll('.promo-badges').forEach(function (badgeEl) {
      badgeEl.remove();
    });
  }

  function injectBadges(widget, options) {
    if (!widget || !widget.data || !Array.isArray(widget.data.products)) return;

    var replace = options && options.replace;
    var globalBadges = parseGlobalBadges();
    var root = getWidgetRoot(widget);

    if (replace) clearBadges(root);

    widget.data.products.forEach(function (product) {
      if (!product || !product.id) return;

      var block = findProductBlock(widget, product.id, root);
      var productBadges = getProductBadges(product);
      var html = buildBadgesHtml(globalBadges, productBadges);

      if (!block) return;
      if (!replace && block.querySelector('.promo-badges')) return;
      if (!html) return;

      block.insertAdjacentHTML('afterbegin', html);
    });
  }

  function disconnectWidgetObserver(widgetId) {
    if (widgetObservers[widgetId]) {
      widgetObservers[widgetId].disconnect();
      delete widgetObservers[widgetId];
    }

    if (widgetRetryTimers[widgetId]) {
      widgetRetryTimers[widgetId].forEach(clearTimeout);
      delete widgetRetryTimers[widgetId];
    }
  }

  function allProductsInjected(widget) {
    if (!widget || !widget.data || !Array.isArray(widget.data.products)) return true;

    var globalBadges = parseGlobalBadges();
    var root = getWidgetRoot(widget);

    return widget.data.products.every(function (product) {
      if (!product || !product.id) return true;

      var block = findProductBlock(widget, product.id, root);
      if (!block) return false;

      var html = buildBadgesHtml(globalBadges, getProductBadges(product));
      if (!html) return true;

      return Boolean(block.querySelector('.promo-badges'));
    });
  }

  function scheduleInject(widget, options) {
    if (!widget || !widget.id) return;

    var widgetId = String(widget.id);
    var replace = options && options.replace;
    disconnectWidgetObserver(widgetId);

    function attemptInject(useReplace) {
      injectBadges(widget, { replace: useReplace });
    }

    var retryTimers = [];

    RETRY_DELAYS_MS.forEach(function (delay, index) {
      var timerId = setTimeout(function () {
        attemptInject(index === 0 ? replace : false);
        if (allProductsInjected(widget)) {
          disconnectWidgetObserver(widgetId);
        }
      }, delay);
      retryTimers.push(timerId);
    });

    widgetRetryTimers[widgetId] = retryTimers;

    var observerTarget = getObserverTarget(widget);
    if (observerTarget && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        attemptInject(false);
        if (allProductsInjected(widget)) {
          disconnectWidgetObserver(widgetId);
        }
      });

      observer.observe(observerTarget, { childList: true, subtree: true });
      widgetObservers[widgetId] = observer;

      setTimeout(function () {
        disconnectWidgetObserver(widgetId);
      }, OBSERVER_TIMEOUT_MS);
    }
  }

  function onWidgetEvent(event, replace) {
    var widget = event.detail && event.detail.widget;
    if (widget) scheduleInject(widget, { replace: replace });
  }

  document.addEventListener('rebuy.ready', function (event) {
    onWidgetEvent(event, false);
  });

  document.addEventListener('rebuy.productsChange', function (event) {
    onWidgetEvent(event, true);
  });

  document.addEventListener('rebuy.refresh', function (event) {
    onWidgetEvent(event, true);
  });
})();
